import { render, staticRenderFns } from "./ApproveTransmittalRequest.vue?vue&type=template&id=26b34064&scoped=true"
import script from "./ApproveTransmittalRequest.vue?vue&type=script&lang=js"
export * from "./ApproveTransmittalRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b34064",
  null
  
)

export default component.exports